import {MenuStrategy} from "../MenuStrategy";

export class CambioPasswordMenuStrategy extends MenuStrategy {
   constructor() {
    super('Cambio Password', 'Cambio Password', 'app-user-change-password');
  }
}
